(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    var videoElem = document.querySelector('.section-bg-video');
    var videoPosterImage = document.querySelector('.section-bg-video-poster');
    var videoEnable = "{{ section.settings.background_video_enable }}";
    
    if(videoEnable === "true") {
        videoElem.style.display = 'block';
        videoPosterImage.style.display = 'none';
    } else {
        videoElem.style.display = 'none';
        videoPosterImage.style.display = 'block';
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.tabs--wrapper_a_p .tab-link').forEach(link => {
      link.addEventListener('click', function() {
          document.querySelectorAll('.tabs--wrapper_a_p .tab-link').forEach(item => item.classList.remove('active'));
          document.querySelectorAll('.tabs--wrapper_a_p .tab').forEach(item => item.classList.remove('active'));
          this.classList.add('active');
          document.getElementById(this.dataset.tab).classList.add('active');
      });
    });
    // Mobile Version
    document.querySelectorAll('.accordions--wrapper_a_p .accordion-header').forEach(header => {
      header.addEventListener('click', function() {
          if (this.classList.contains('active')) {
              this.classList.remove('active');
              document.getElementById(this.dataset.tab).classList.remove('active');
          } else {
              document.querySelectorAll('.accordions--wrapper_a_p .accordion-header').forEach(item => item.classList.remove('active'));
              document.querySelectorAll('.accordions--wrapper_a_p .accordion-content').forEach(item => item.classList.remove('active'));
              this.classList.add('active');
              document.getElementById(this.dataset.tab).classList.add('active');
          }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
